/**
 * Contact Inquiry Service - Lake Charles
 * Handles contact form submissions to unified multi-city API
 */

// @ts-ignore - Vite env vars
const API_BASE_URL = import.meta.env?.VITE_API_BASE_URL || 'https://api.toolboxlogic.com';

export interface ContactInquiryData {
  fullName: string;
  email: string;
  subject: string;
  message: string;
}

export interface ContactInquiryResponse {
  success: boolean;
  error?: string;
  data?: {
    id: string;
    created_at: string;
  };
}

/**
 * Submit contact inquiry to Lake Charles endpoint
 */
export async function submitContactInquiry(
  formData: ContactInquiryData,
): Promise<ContactInquiryResponse> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/louisiana/lake-charles/contact-inquiry`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || `HTTP ${response.status}: ${response.statusText}`,
      };
    }

    return {
      success: true,
      data: data.data,
    };
  } catch (error) {
    console.error('Contact inquiry submission error:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Network error occurred',
    };
  }
}
